import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetCurrentUser } from '../selectors/users';
import { makeGetCurrentTeam } from '../selectors/teams';

import { hasMessaging, requestNotificationsPermission } from '../services/browser-notification-service';

import Alert from './alert';

class BrowserNotificationRequest extends PureComponent {
    state = {
        visible: false
    }

    handleEnableNotificationsClick = event => {
        event.preventDefault();

        this.setState({
            visible: false
        });

        requestNotificationsPermission();
    }

    handleClose = () => {
        this.setState({
            visible: false
        });
    }

    init() {
        if (!hasMessaging()) {
            return;
        }

        if (!['denied', 'granted'].includes(Notification.permission)) {
            this.setState({
                visible: true
            });
        }
    }

    componentDidMount() {
        if (this.props.canInit) {
            this.init();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.canInit && !prevProps.canInit) {
            this.init();
        }
    }

    render() {
        if (this.state.visible) {
            return (
                <Alert type="default" icon={<i className="icon material-icons">error</i>} manualClose={true} onClose={this.handleClose}>
                     <a href="#enablePush" onClick={this.handleEnableNotificationsClick}>Enable push notifications</a> to get notified about new messages, mentions, tasks, and more.
                </Alert>
            )
        }

        return null;
    }
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();
    const getCurrentTeam = makeGetCurrentTeam();

    return ({ users, teams }) => {
        return {
            canInit: getCurrentUser(users) && getCurrentTeam(teams)
        }
    };
};

export default connect(makeMapStateToProps)(BrowserNotificationRequest);
